import { Injectable } from '@angular/core';
import { UrlGeneratorService } from '@app/core/i18n';
import { Model, Picture, Price, Product, ProductMeasurement, User } from '@vestiaire/api-sdk-angular';
import { environment } from '@env/environment';

@Injectable()
export class ProductMicrodatasService {
  public schema: {};

  constructor(private urlGenerator: UrlGeneratorService) {}

  private computeImagePath(pictureData: Array<Picture>) {
    const pictureDataFormated: Array<String> = [];
    let item: String = '';
    Object.keys(pictureData).forEach(itemKey => {
      item = environment.imgixPath + '/produit/' + pictureData[itemKey].path;
      pictureDataFormated.push(item);
    });

    return pictureDataFormated;
  }

  private computeMeasurment(measurmentData: Array<ProductMeasurement>, unit: String) {
    const authorizedMeasurments: Array<string> = ['height', 'width', 'depth'];

    Object.keys(measurmentData).forEach(itemKey => {
      if (measurmentData[itemKey].name) {
        if (authorizedMeasurments.includes(measurmentData[itemKey].name.toLowerCase())) {
          this.schema[measurmentData[itemKey].name] = {
            '@type': 'QuantitativeValue',
            value: measurmentData[itemKey].value
          };
          if (unit) {
            this.schema[measurmentData[itemKey].name].unitCode = unit;
          }
        }
      }
    });
  }

  private computeDescription(description: String) {
    return description
      .split(' ')
      .slice(0, 50)
      .join(' ');
  }

  private populateProductModel(modelData: Model) {
    return {
      '@type': 'ProductModel',
      name: modelData.name
    };
  }

  private formatPrice(priceData: Price): String {
    const price: number = priceData.cents / 100;
    return price.toString();
  }

  private populateSeller(sellerData: User) {
    const sellerDataDataFormated: object = {};

    if (sellerData.badges.includes('pro')) {
      sellerDataDataFormated['@type'] = 'Organization';
    } else {
      sellerDataDataFormated['@type'] = 'Person';
    }

    sellerDataDataFormated['name'] = sellerData.firstname;

    return sellerDataDataFormated;
  }

  getDatas(productData: Product) {
    // Required data
    this.schema = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      url: this.urlGenerator.generateUrl(productData.path),
      name: productData.name,
      sku: productData.id,
      brand: {
        '@type': 'Thing',
        name: productData.brand.name
      },
      offers: {
        '@type': 'Offer',
        priceCurrency: productData.price.currency,
        itemCondition: 'https://schema.org/UsedCondition',
        availability: 'https://schema.org/InStock'
      }
    };

    this.schema['offers'].price = this.formatPrice(productData.price);

    this.schema['offers'].seller = this.populateSeller(productData.seller);

    if (!productData.available) {
      this.schema['offers'].availability = 'https://schema.org/SoldOut';
    }

    // Non required data
    if (productData.pictures) {
      this.schema['image'] = this.computeImagePath(productData.pictures);
    }

    if (productData.description) {
      this.schema['description'] = this.computeDescription(productData.description);
    }

    if (productData.category && productData.category.localizedName) {
      this.schema['category'] = productData.category.localizedName;
    }

    if (productData.color && productData.color.localizedName) {
      this.schema['color'] = productData.color.localizedName;
    }

    if (productData.material && productData.material.localizedName) {
      this.schema['material'] = productData.material.localizedName;
    }

    if (productData.measurements && productData.unit) {
      this.computeMeasurment(productData.measurements, productData.unit);
    }

    if (productData.model) {
      this.schema['model'] = this.populateProductModel(productData.model);
    }

    return this.schema;
  }
}
